"use strict";

import {onEnterViewPort} from "@elements/viewport-utils";

export function initInScope($scope) {
    onEnterViewPort($scope.find('.js-scale-up'), function () {
        let $items = $(this);
        $items.each(function(){
            let finalWidth = $(this).attr('aria-valuenow');
            $(this).width(finalWidth + '%');
        });
    });

    onEnterViewPort($scope.find('.js-scale-up-vertical'), function () {
        let $itemsVertical = $(this);
        $itemsVertical.each(function(){
            let finalHeight = $(this).attr('aria-valuenow');
            $(this).height(finalHeight + '%');
        });
    });
}